// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-view .record-dialog .el-form-item__label {\n  line-height: 22px;\n  text-align: left;\n}\n.student-view .record-dialog .dialog-footer {\n  justify-content: center;\n}\n.student-view .colorRed .el-input__inner {\n  color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
